<div class="tw-p-4">
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-title class="matp-dialog-title">
    <span class="absolute h-14 w-14 top-0 start-0"
      >デバイス設定グループ{{ updating ? "編集" : "新規登録" }}</span
    >
  </div>

  <mat-dialog-content class="!tw-pt-2 tw-max-h-1/2">
    <form [formGroup]="formGroup">
      <div class="tw-flex tw-gap-8">
        <mat-form-field
          class="tw-my-2 tw-w-1/2"
          appearance="outline"
          floatLabel="always"
          [ngClass]="{ 'matp-form-field-readonly': false }"
        >
          <mat-label>設定グループ名</mat-label>
          <input
            matInput
            formControlName="deviceSettingGroupName"
            name="deviceSettingGroupName"
            required
          />
          <mat-error
            *ngIf="
              formGroup.controls.deviceSettingGroupName.errors?.['required']
            "
          >
            設定グループ名を入力してください。
          </mat-error>
          <mat-error
            *ngIf="
              formGroup.controls.deviceSettingGroupName.errors?.['maxlength']
            "
          >
            50文字以下で入力してください。
          </mat-error>
        </mat-form-field>
        <mat-form-field
          class="tw-my-2 tw-w-1/2"
          appearance="outline"
          floatLabel="always"
        >
          <mat-label>デバイス種類</mat-label>
          <mat-select
            formControlName="deviceTypeKey"
            (selectionChange)="filterDeviceType()"
          >
            @for (deviceType of deviceTypeList; track deviceType.deviceTypeKey) {
              <mat-option [value]="deviceType.deviceTypeKey">
                {{ deviceType.displayName }}
              </mat-option>
            }
          </mat-select>
          <mat-error
            *ngIf="formGroup.controls.deviceTypeKey.errors?.['required']"
          >
            デバイス種類を入力してください
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field
        class="tw-my-2 tw-w-full"
        appearance="outline"
        floatLabel="always"
        [ngClass]="{ 'matp-form-field-readonly': false }"
      >
        <mat-label>グループ説明</mat-label>
        <textarea
          matInput
          formControlName="description"
          name="description"
        ></textarea>
        <mat-error *ngIf="formGroup.controls.description.errors?.['maxlength']">
          200文字以下で入力してください。
        </mat-error>
      </mat-form-field>
    </form>

    <div class="tw-flex tw-w-full tw-justify-between">
      <div class="tw-w-2/5">
        <p>グループに所属するデバイス</p>
        <div
          class="matp-table-area tw-border-solid tw-border-gray-200 tw-border-2 tw-h-80 tw-max-h-4/5 tw-overflow-y-scroll tw-w-full"
        >
          <table
            mat-table
            [dataSource]="dataSourceGroupDevice"
            class="matp-table"
          >
            <ng-container matColumnDef="checkbox">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="matp-table-header-middle !tw-min-w-min"
              >
                <mat-checkbox
                  color="primary"
                  (change)="$event ? toggleAllGroupDeviceRows() : null"
                  [checked]="
                    selectionGroupDevice.hasValue() &&
                    isAllGroupDeviceSelected()
                  "
                  [indeterminate]="
                    selectionGroupDevice.hasValue() &&
                    !isAllGroupDeviceSelected()
                  "
                ></mat-checkbox>
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="tw-w-2"
                [ngClass]="{ '!tw-bg-gray-300': element.expired }"
              >
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="
                    $event ? selectionGroupDevice.toggle(element) : null
                  "
                  [disabled]="element.expired"
                  [checked]="selectionGroupDevice.isSelected(element)"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="deviceName">
              <th class="tw-w-2/5 tw-h-20" mat-header-cell *matHeaderCellDef>
                <div class="matp-table-header-title">デバイス名</div>
                <mat-form-field
                  appearance="outline"
                  class="matp-form-field-slim"
                >
                  <input
                    matInput
                    name="deviceNameFilter"
                    type="text"
                    [(ngModel)]="groupDeviceNameKeyword"
                    (keyup)="applyGroupDeviceDataSourceFilter()"
                  />
                  <button
                    type="button"
                    id="devicename-filter-clear-btn"
                    matSuffix
                    mat-icon-button
                    (click)="clearGroupDeviceNameFilter()"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </th>
              <td
                class="tw-w-2/5"
                mat-cell
                *matCellDef="let element"
                [ngClass]="{
                  '!tw-bg-gray-300': element.expired,
                  'tw-text-gray-500': element.expired,
                }"
              >
                <span>
                  {{
                    element.deviceName !== ""
                      ? element.deviceName
                      : element.deviceId
                  }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="deviceId">
              <th class="tw-w-2/5" mat-header-cell *matHeaderCellDef>
                <div class="matp-table-header-title">シリアルナンバー</div>
                <mat-form-field
                  appearance="outline"
                  class="matp-form-field-slim"
                >
                  <input
                    matInput
                    name="deviceIdFilter"
                    type="text"
                    [(ngModel)]="groupDeviceIdKeyword"
                    (keyup)="applyGroupDeviceDataSourceFilter()"
                  />
                  <button
                    type="button"
                    id="deviceid-filter-clear-btn"
                    matSuffix
                    mat-icon-button
                    (click)="clearGroupDeviceIdFilter()"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </th>
              <td
                class="tw-w-2/5"
                mat-cell
                *matCellDef="let element"
                [ngClass]="{
                  '!tw-bg-gray-300': element.expired,
                  'tw-text-gray-500': element.expired,
                }"
              >
                <span>
                  {{ element.deviceId }}
                </span>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>
      <div class="tw-flex tw-mt-14 tw-justify-center tw-items-center">
        <div class="tw-flex tw-flex-col tw-my-5">
          <button
            type="button"
            mat-raised-button
            class="tw-rounded tw-px-4 tw-py-2 tw-my-4 tw-mt-4"
            type="button"
            color="primary"
            (click)="moveToGroupDeviceList()"
          >
            <div class="tw-grid tw-grid-cols-2">
              <mat-icon>keyboard_double_arrow_left</mat-icon>
              追加
            </div>
          </button>

          <button
            type="button"
            mat-raised-button
            class="tw-rounded tw-px-4 tw-py-2 tw-my-4"
            type="button"
            color="primary"
            (click)="moveToDeviceList()"
          >
            <div class="tw-grid tw-grid-cols-2">
              <mat-icon>keyboard_double_arrow_right</mat-icon>
              解除
            </div>
          </button>
        </div>
      </div>
      <div class="tw-w-2/5 tw-h-50">
        <p>無所属のデバイス</p>
        <div
          class="tw-border-solid tw-border-gray-200 tw-border-2 tw-h-80 tw-max-h-4/5 tw-overflow-y-scroll tw-w-full"
        >
          <table mat-table [dataSource]="dataSourceDevice" class="matp-table">
            <ng-container matColumnDef="checkbox">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="matp-table-header-middle !tw-min-w-min"
              >
                <mat-checkbox
                  color="primary"
                  (change)="$event ? toggleAllDeviceRows() : null"
                  [checked]="
                    selectionDevice.hasValue() && isAllDeviceSelected()
                  "
                  [indeterminate]="
                    selectionDevice.hasValue() && !isAllDeviceSelected()
                  "
                ></mat-checkbox>
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="tw-w-2"
                [ngClass]="{ '!tw-bg-gray-300': element.expired }"
              >
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selectionDevice.toggle(element) : null"
                  [checked]="selectionDevice.isSelected(element)"
                  [disabled]="element.expired"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="deviceName">
              <th class="tw-w-2/5" mat-header-cell *matHeaderCellDef>
                <div class="matp-table-header-title">デバイス名</div>
                <mat-form-field
                  appearance="outline"
                  class="matp-form-field-slim tw-w-36"
                >
                  <input
                    matInput
                    name="deviceNameFilter"
                    type="text"
                    [(ngModel)]="deviceNameKeyword"
                    (keyup)="applyDeviceDataSourceFilter()"
                  />
                  <button
                    type="button"
                    id="devicename-filter-clear-btn"
                    matSuffix
                    mat-icon-button
                    (click)="clearDeviceNameFilter()"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </th>
              <td
                class="tw-w-2/5"
                mat-cell
                *matCellDef="let element"
                [ngClass]="{
                  '!tw-bg-gray-300': element.expired,
                  'tw-text-gray-500': element.expired,
                }"
              >
                <span>
                  {{
                    element.deviceName !== ""
                      ? element.deviceName
                      : element.deviceId
                  }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="deviceId">
              <th class="tw-w-2/5" mat-header-cell *matHeaderCellDef>
                <div class="matp-table-header-title">シリアルナンバー</div>
                <mat-form-field
                  appearance="outline"
                  class="matp-form-field-slim tw-w-36"
                >
                  <input
                    matInput
                    name="deviceIdFilter"
                    type="text"
                    [(ngModel)]="deviceIdKeyword"
                    (keyup)="applyDeviceDataSourceFilter()"
                  />
                  <button
                    type="button"
                    id="deviceid-filter-clear-btn"
                    matSuffix
                    mat-icon-button
                    (click)="clearDeviceIdFilter()"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </th>
              <td
                class="tw-w-2/5"
                mat-cell
                *matCellDef="let element"
                [ngClass]="{
                  '!tw-bg-gray-300': element.expired,
                  'tw-text-gray-500': element.expired,
                }"
              >
                <span>
                  {{ element.deviceId }}
                </span>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
    <button
      type="button"
      id="btn-cancel-add-asset-type"
      mat-raised-button
      mat-dialog-close
      class="tw-w-40"
    >
      <mat-icon>close</mat-icon>
      キャンセル
    </button>
    <button
      id="btn-add-asset-type"
      mat-raised-button
      color="accent"
      class="tw-w-40"
      type="button"
      (click)="submit()"
      [disabled]="formGroup.invalid"
    >
      <mat-icon>done</mat-icon>
      <span>{{ updating ? "変更" : "新規登録" }}</span>
    </button>
  </mat-dialog-actions>
</div>

<!-- <div class="matp-table-area">
          <table mat-table [dataSource]="dataSource" id="device-setting-group-table" class="matp-table">

      
            <ng-container matColumnDef="deviceName">
              <th class="tw-w-1/6" mat-header-cell *matHeaderCellDef>
                          <div mat-sort-header class="matp-table-header-title">
                            デバイス名
                          </div>
                          <mat-form-field appearance="outline" class="matp-form-field-slim">
                            <input name="deviceName" matInput name="deviceNameFilter" type="text"
                              [(ngModel)]="deviceNameKeyword" (keyup)="dataSource.filter = deviceNameKeyword" />
                            <button id="devicename-filter-clear-btn" matSuffix mat-icon-button (click)="
                                                                                    deviceNameKeyword = ''; dataSource.filter = deviceNameKeyword
                                  ">
                              <mat-icon>close</mat-icon>
                            </button>
                          </mat-form-field>
                        </th>
              <td class="tw-w-1/6" mat-cell name="deviceName" *matCellDef="let element">
                {{ element.deviceName }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div> -->
